export default __webpack_public_path__ + "static/media/kanipakamHistoryTwo.865720ab.png";